import React from 'react';
import { Input } from './input';

export function DeferredInput({
  value,
  onCommit,
  ...props
}: {
  value?: string;
  onCommit: (value: string) => void;
} & React.ComponentProps<typeof Input>) {
  const [localValue, setLocalValue] = React.useState(value || '');

  React.useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  return (
    <Input
      {...props}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onCommit(localValue)}
    />
  );
}
